import React from 'react';
import PropTypes from 'prop-types';
import {
  TextTitle,
  getPanelErrorProps,
  ValidatedFixedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';

import { ValidatedCampaignName } from '../validated-campaign-name';
import { SingleLineShimmer, withShimmer } from '../shimmers';

const ValidatedCampaignNameWithShimmer = withShimmer(ValidatedCampaignName, SingleLineShimmer);

export const CampaignNamePanel = ({ key, isLoading, ...rest }) => (
  <ValidatedFixedPanel
    key={key}
    title={<TextTitle titleKey={_TL_('Campaign name')} topicKey="pop_BA_CampaignCreate_Settings_CampaignName" />}
    attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
    {...rest}
  >
    <ValidatedCampaignNameWithShimmer showShimmer={isLoading} />
  </ValidatedFixedPanel>
);

CampaignNamePanel.propTypes = {
  key: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

CampaignNamePanel.defaultProps = {
  isLoading: false,
};
